module.exports = __webpack_public_path__ + "img/cruzeiro.a51d650e.jpeg";